import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listLoading: false,
  actionsLoading: false,
  lastError: null,
  error: null,

  presentDays: 0,
  absentDays: 0,
  leaveApplied: 0,
  pendingLeave: 0,
  workTimeData: [],
  workLog: {},
  weekend: [],
  holiday: [],
  holidayLists: [],
  birthdays: [],
  pendingApproval: 0,

  hrPresent: 0,
  hrAbsent: 0,
  hrLate: 0,
  hrPending: 0,
  leaveCount: 0,
  separated_employee_count: 0,
  salary_profile_incomplete_count: 0,
  official_profile_incomplete_count: 0,
  activeEmp: 0,
  maleEmployee: 0,
  femaleEmployee: 0,
  totalEmployee: 0,
  lateDays: 0,
  earlyOutDays: 0,

  lastTenDaysAtt: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },

    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    // getrequisitonById
    cardFetched: (state, action) => {
      state.actionsLoading = false;
      state.absentDays = action.payload.absentDays;
      state.presentDays = action.payload.presentDays;
      state.workTimeData = action.payload.workTimeData;
      state.earlyOutDays = action.payload.earlyOutDays;
      state.lateDays = action.payload.lateDays;
      state.error = null;
    },

    tenDaysAttendanceFetched: (state, action) => {
      state.actionsLoading = false;
      state.lastTenDaysAtt = action.payload.lastTenDaysAtt;
      state.error = null;
    },

    leaveFetched: (state, action) => {
      state.actionsLoading = false;
      state.leaveApplied = action.payload.leaveApplied;
      state.pendingApproval = action.payload.pendingApproval;
      state.error = null;
    },

    calenderFetched: (state, action) => {
      state.actionsLoading = false;
      state.weekend = action.payload.weekend;
      state.holiday = action.payload.holiday;
      state.error = null;
    },

    holidayFetched: (state, action) => {
      state.actionsLoading = false;
      state.holidayLists = action.payload.holidayLists;
      state.error = null;
    },

    birthdayFetched: (state, action) => {
      state.actionsLoading = false;
      state.birthdays = action.payload.birthdays;
      state.error = null;
    },

    totalEmployeeFetched: (state, action) => {
      state.actionsLoading = false;
      state.maleEmployee = action.payload.maleEmployee;
      state.femaleEmployee = action.payload.femaleEmployee;
      state.totalEmployee = action.payload.totalEmployee;
      state.error = null;
    },

    hrCardFetched: (state, action) => {
      state.actionsLoading = false;
      state.hrPresent = action.payload.hrPresent;
      state.hrAbsent = action.payload.hrAbsent;
      state.hrLate = action.payload.hrLate;
      state.hrPending = action.payload.hrPending;
      state.activeEmp = action.payload.activeEmp;
      state.official_profile_incomplete_count =
        action.payload.official_profile_incomplete_count;
      state.salary_profile_incomplete_count =
        action.payload.salary_profile_incomplete_count;
      state.separated_employee_count = action.payload.separated_employee_count;
      state.leaveCount = action.payload.leaveCount;
      state.error = null;
    },

    todayAttendanceFetched: (state, action) => {
      state.actionsLoading = false;
      state.workLog = action.payload.workLog;
      state.error = null;
    },
  },
});
